export default class CompetitorQualify {
  constructor (data) {
    this.id = data.id
    this.disciplineId = data.disciplineId
    this.codeIoc = data.codeIoc
    this.name = data.nameFr
    this.shortname = data.shortnameFr
  }
}
